<template>
    <div :style="{gridTemplateColumns:`repeat(${cols},1fr)`,gap:gap+'px'} " class="list-container">
        <div :style="{gridColumn: i%cols+1,gridRow: Math.ceil((i+1)/cols)}"
                v-for="(o,i) in data" :key="i">
            <slot :item="o"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "GridBox",
    props: {
        cols: Number,
        gap: Number,
        data: Array,
    },
}
</script>
<style scoped>
.list-container {
    display: grid;
    padding: 20px 0;
}
</style>